import React from 'react';
import { actions as formActions, Control, Form } from 'react-redux-form';
import { Button } from 'react-bootstrap';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import FontAwesome from 'utils/FA';
import registeredComponent from 'utils/registeredComponent';
import { duckify, filterDuck, singleDuck, withForm } from 'utils/duckify';
import { modals, contractFees, paymentPlanForm, paymentPlans, paymentPlanSchedules, schoolYears } from 'ducks';
import { ensureKeyed } from 'utils';
import ValidationErrors from '../../forms/ValidationErrors';
import ControlGroup from '../../forms/ControlGroup';
import ModalComponent from '../../ModalComponent';
import Placeholder from '../../Placeholder';

import './styles/PaymentPlanSchedules.scss';

class PaymentPlanEditor extends React.Component {

  static defaultProps = {
    planId: null,
    saving: false,
    contractFees: {},
    paymentPlan: {},
    paymentPlanForm: {},
    schoolYearId: null
  };

  constructor(props) {
    super(props);
    this.renderScheduleEditor = this.renderScheduleEditor.bind(this);
  };

  save(closeModal) {
    const {dispatch} = this.props;
    const model = this.props.paymentPlanForm.model;
    dispatch(modals.actions.update({saving: true}));
    dispatch(paymentPlanForm.actions.save({...model}))
      .then((response) => {
        dispatch(modals.actions.hide());
        if (!closeModal) {

          // If closeModal is false, we want to apply the changes and reload the modal
          dispatch(modals.actions.show('PaymentPlanEditor', {
            schoolYearId: response.school_year_id,
            planId: response.id
          }))
        }
      })
      .then(() => dispatch(paymentPlans.actions.markDirty()))
      .catch((response) => {
        if (!response.payment_plan) {
          dispatch(modals.actions.hide());
          dispatch(modals.actions.show('UnexpectedError'));
        } else {
          dispatch(formActions.load("paymentPlanForm.model", response.payment_plan));
        }
      }).then(() => dispatch(modals.actions.update({saving: false})));
  };


  renderScheduleEditor = (id, schoolYear, position = null) => {
    const {dispatch} = this.props;
    const planForm = this.props.paymentPlanForm.model;
    dispatch(modals.actions.show('PaymentPlanScheduleEditor', {
      position: position,
      planForm: planForm,
      scheduleId: id,
      schoolYear: schoolYear
    }))
  };

  delete = (schedule, index) => {
    const {dispatch} = this.props;
    dispatch(paymentPlanSchedules.actions.remove(schedule))
      .then(() => dispatch(formActions.remove('paymentPlanForm.model.payment_plan_schedules', index)))
      .catch(() => dispatch(formActions.push("paymentPlanForm.model.errors", "Something went wrong. Schedule could not be deleted.")))
  };

  render() {
    const {allDucksReady} = this.props;
    const {saving, contractFees, schoolYear, planId} = this.props;
    const planForm = allDucksReady ? this.props.paymentPlanForm.model : null;
    const buttons = [
      <Button variant="primary"
              disabled={saving}
              className="ms-1"
              onClick={() => this.save(true, false)}>{saving ? 'Saving...' : 'Save'}</Button>,
      <Button variant="success"
              disabled={saving}
              className="ms-1"
              onClick={() => this.save(false, false)}>{saving ? 'Applying...' : 'Apply'}</Button>,

    ];

      return (
        <ModalComponent className="payment-plan-editor-modal" buttons={buttons} title={planId ? "Edit Payment Plan" : "Create Payment Plan"}>
          {allDucksReady ?
        <div>
          <ValidationErrors errors={planForm.errors}/>
          <Form model={paymentPlanForm.model}>
            <ControlGroup label="Name">
              <Control.text className="form-control form-control-sm" model='.canonical_name' disabled={!!planId}/>
            </ControlGroup>
            <ControlGroup label="Number Of Payments">
              <Control.select className="form-select form-select-sm" model='.number_of_payments' defaultValue={planId ? undefined : 0}>
                {Array.from(Array(13).keys()).map(number => <option
                  value={number}>{number == 0 ? "Due Immediately" : number}</option>).map(ensureKeyed())}
              </Control.select>
            </ControlGroup>
            {!schoolYear.billing_enabled &&
            <ControlGroup label="Term Length">
              <Control.text className="form-control form-control-sm" model='.term_length'/>
            </ControlGroup>
            }
            <h4>Plan Schedules</h4>
            {!planId ?
              <span className={'payment-plan-schedule-description'}>Payment Plan must be saved before schedules can be added.</span> :
              <div>
                {planForm.payment_plan_schedules.some(x=>x) &&
                  <table className='crud-table table payment-plan-schedules'>
                    <thead>
                      <tr>
                        <th>Start Month</th>
                        <th>Start Year</th>

                        <th>Payments</th>
                        <th />
                      </tr>
                    </thead>
                    {planForm.payment_plan_schedules.map((schedule, index) =>
                      <tbody>
                        <tr>
                          <td>{schedule.immediate ? "Due Immediately" : schedule.start_month}</td>
                          <td>{schedule.immediate ? "Due Immediately" : schedule.start_year}</td>
                          <td>{schedule.immediate ? 1 : schedule.number_of_payments}</td>
                          {!schedule.immediate && (
                            <td className='payment-plan-schedules-actions'>
                              <button
                                type='button'
                                className={'btn btn-sm btn-primary'}
                                onClick={() => this.renderScheduleEditor(schedule.id, schoolYear, index)}
                              >
                                <FontAwesome icon={faPencil} />
                              </button>
                              <button
                                className={'btn btn-sm btn-danger'}
                                onClick={() => this.delete(schedule, index)}
                                type='button'
                              >
                                <FontAwesome icon={faTrash} />
                              </button>
                            </td>
                          ) }
                        </tr>
                      </tbody>
                    ).map(ensureKeyed())}
                  </table>
                }
                {((schoolYear.billing_enabled || planForm.payment_plan_schedules.length < 1) && !this.props.paymentPlan.immediate) &&
                  <button className={'btn btn-light'} onClick={() => this.renderScheduleEditor(null, schoolYear)}> Add New
                    Schedule <FontAwesome name="plus green"/></button>
                }
              </div>}
            <ControlGroup label="Explanation">
              <Control.textarea className="form-control form-control-sm" model='.explanation'/>
            </ControlGroup>
            <ControlGroup label="Contractual Text">
              <Control.textarea className="form-control form-control-sm" model='.contractual_text'/>
            </ControlGroup>
            <ControlGroup label="Confirmation Text">
              <Control.textarea className="form-control form-control-sm" model='.confirmation_text'/>
            </ControlGroup>
            <ControlGroup label="Contract Fees" checkbox>
              <div className='plan-editor-payment-plan-fees'>
                {
                  contractFees.map(fee => (
                    <div className='plan-editor-payment-plan-fee'>
                      <Control.checkbox model='.contract_fees[]' value={fee.id} />
                      {fee.name}
                    </div>
                  )).map(ensureKeyed())
                }
              </div>
            </ControlGroup>
            <ControlGroup label="Business Rule">
              <Control.text className="form-control form-control-sm" model='.business_rule'/>
            </ControlGroup>
            <ControlGroup label="Default" checkbox>

              <Control.checkbox model='.is_default'/>
            </ControlGroup>
            <ControlGroup label="Active" checkbox>
              <Control.checkbox model='.active'/>
            </ControlGroup>
            <Control.text className='form-control form-control-sm hide-schedule-field' disabled={true} model={'.school_year_id'}
                          defaultValue={schoolYear.id}/>
          </Form>
        </div> : <Placeholder.loading/>}
      </ModalComponent> )
    }
  }

const FEE_KEY = 'paymentPlanFees';


function mapDucksToProps (props) {
  const plan = singleDuck(paymentPlans, props.planId);
  return {paymentPlan: plan,
         contractFees: filterDuck(contractFees, {active: true, charge_type: 'payment_plan', school_year_id: props.schoolYearId}, FEE_KEY),
         paymentPlanForm: withForm(plan, paymentPlanForm),
         schoolYear: singleDuck(schoolYears, props.schoolYearId),
       }
}



export default registeredComponent("PaymentPlanEditor")(duckify(mapDucksToProps)(PaymentPlanEditor))
